import axios from 'axios';
import { getCookie, removeCookie, setCookie } from 'src/utils/cookies';
import { jwtDecode } from 'src/utils/jwtDecode';
import { VALIDATE_TOKEN, REFRESH_TOKEN } from 'src/constants/httpEndPoints';

const fetchNewToken = async (): Promise<string | null | undefined> => {
  try {
    const currentRefToken = getCookie('refresh');

    if (!currentRefToken) {
      return null;
    }

    const response = await axios.post(REFRESH_TOKEN, { refreshToken: currentRefToken });
    if (response.data.status === 200) {
      const token: string = response.data.accessToken;
      const refreshToken = response.data.refreshToken;
      setCookie('user', token);
      setCookie('refresh', refreshToken);
      // Lazy import to break circular dependency: rootStore → login → apiClient → fetchNewToken → rootStore
      const { rootStore } = await import('src/app/rootStore');
      const { userLoginAction } = await import('src/store/login');
      rootStore.dispatch(userLoginAction({ token }));
      return token;
    } else if (response.data.status === 400) {
      removeCookie('user');
      removeCookie('refresh');
      localStorage.clear();
      window.location.href = '/login';
      localStorage.setItem('chatbotLastOpened', new Date().toDateString());
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log('error: ', error);
    removeCookie('user');
    removeCookie('refresh');
    localStorage.clear();
    window.location.href = '/login';
    localStorage.setItem('chatbotLastOpened', new Date().toDateString());
    return null;
  }
};

export { fetchNewToken };
